import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';

import { OpcionModel } from '../Global/Opcion.model';
import { ConsultarEstadoFacturaModel } from './ConsultarEstadoFactura.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';


@Component({
	selector: 'consultarLog',
	templateUrl: './ConsultarEstadoFactura.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Camilo
* @since  01/10/2018
**/
export class FacturacionElectronicaConsultarEstadoFactura {

	public form: FormGroup;
	public formErrors: any;

	public fechaInicio: Date ;
	public fechaFin: Date ;
	public prefijo: string = '';
	public numeroInicio: string = '';
	public numeroFin: string = '';

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;

	public dataDataBase: NegociosDatabase;
	public dataSource: ExampleDataSource;

	public btnConsultar: boolean;

	public displayedColumns = ['emisor', 'nitEmisor', 'negocio', 'prefijo', 'numeroDocumento', 'fechaFactura', 'estadoEnvioCen', 'mensajeRespuestaCarvajal', 'validacionDian', 'mensajeRespuestaDian'];
	public cargando: boolean = false;
	public render: boolean = false;

	public ocultar: boolean = false;
	public mensaje: string = "";

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

		this.snackBar.dismiss();

	}


	ngOnInit() {
		this.inicializarForm();
	}



	inicializarForm() {
		this.formErrors = {
			fechaInicio: {},
			fechaFin: {},
			prefijo: {},
			numeroInicio: {},
			numeroFin: {}
		};


		this.form = this.formBuilder.group({
			fechaInicio: [''],
			fechaFin: [''],
			prefijo: [''],
			numeroInicio: [''],
			numeroFin: ['']
			/*numero: ['', Validators.required],
			negocio: ['', Validators.required]*/
		});
	}





	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}



	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

	consultar() {

		this.cargando = true;
		this.render = false;

		this.dataDataBase = new NegociosDatabase();
		let parametros = { fechaInicio: this.fechaInicio, fechaFin: this.fechaFin, prefijo: this.prefijo, numeroInicio: this.numeroInicio, numeroFin: this.numeroFin };
		this._serviciosGenerales.get('servicioFacturacionElectronica/consultarEstadoFactura', parametros).subscribe(
			result => {
				console.log(result);


				if (result.error != undefined && result.error == true) {
					this.openSnackBarEspecial(result.mensaje, "X");
				} else {
					this.render = true;
					for (let x = 0; x < result.length; x++) {
						let temp = result[x];
						console.log(temp);
						let log = new ConsultarEstadoFacturaModel(
							temp.EMISOR,
							temp.NITEMISOR,
							temp.NEGOCIO,
							temp.PREFIJO,
							temp.NUMERO_DOCUMENTO,
							temp.FECHA_FACTURA,
							temp.ESTADO_ENVIO_CENF,
							temp.MENSAJE_RESPUESTA_CARVAJAL,
							temp.VALIDACION_DIAN,
							temp.MENSAJE_RESPUESTA_DIAN)
						console.log(log);
						this.dataDataBase.addNegocio(log);
					}
					this.dataSource = new ExampleDataSource(this.dataDataBase);
				}
				this.cargando = false;

			}, error => {
				console.log(error);
				this.cargando = false;
			}
		)

	}

}


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class NegociosDatabase {

	dataChange: BehaviorSubject<ConsultarEstadoFacturaModel[]> = new BehaviorSubject<ConsultarEstadoFacturaModel[]>([]);

	get data(): ConsultarEstadoFacturaModel[] {
		return this.dataChange.value;
	}

	addNegocio(log: ConsultarEstadoFacturaModel) {
		const copiedData = this.data.slice();
		copiedData.push(log);
		this.dataChange.next(copiedData);
	}

}

export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: NegociosDatabase) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<ConsultarEstadoFacturaModel[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: ConsultarEstadoFacturaModel) => {
				let searchStr = (item.EMISOR).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/FacturacionElectronicaConsultarEstadoFactura/ConsultarEstadoFactura.component.ts